import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Auth from './components/Auth';
import Dashboard from './components/Dashboard';
import ActiveRound from './components/ActiveRound';
import Standings from './components/Standings';
import Navbar from './components/Navbar';
import Profile from './components/Profile';
import AdminPanel from './components/AdminPanel';
import PublicStandings from './components/PublicStandings';
import ResetPassword from './components/ResetPassword'; // Adjust path if needed!
import Footer from './components/Footer';
import Guide from './components/Guide';
import Terms from './components/Terms';
import TournamentDetails from './components/TournamentDetails';
import CreateTournament from './components/CreateTournament';
import CircuitDetails from './components/CircuitDetails';


// Simple guard to protect routes
const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    return token ? children : <Navigate to="/auth" />;
};

function App() {
    return (
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Router>
            
            <div className="app-container">
                <Navbar /> 
                <Routes>                    
                    <Route path="/tournament/:id/standings" element={
    <PrivateRoute><Standings /></PrivateRoute>
} />
{/* PUBLIC ROUTES */}
<Route path="/public/tournament/:id" element={<PublicStandings />} />
                    <Route path="/auth" element={<Auth />} />
                    <Route path="/dashboard" element={
                        <PrivateRoute><Dashboard /></PrivateRoute>
                    } />
                    <Route path="/profile" element={<Profile />}/>
                    <Route path="admin" element={<AdminPanel />}/>
                    <Route path="/tournament/:id" element={
                        <PrivateRoute><TournamentDetails /></PrivateRoute>
                    } />
                    <Route path="/tournament/:id/active" element={<ActiveRound />}/>
                    <Route path="*" element={<Navigate to="/dashboard" />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/guide" element={<Guide />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/create-tournament" element={<CreateTournament />} />
            <Route path="/circuit/:id" element={<CircuitDetails />} />
                </Routes>
                 <Footer />
            </div>
            
        </Router>
        </div>
    );
}

export default App;